<template>
  <div class="error-container">
    <div class="error">
      <div class="error__header">Life is like a box of chocolates</div>
      <div class="error__tip">You never know what error you're going to get.</div>
      <div v-if="!isProd" class="error__debug">
        <div>
          Status code:
          <strong>{{ error.statusCode }}</strong>
        </div>
        <div>{{ error.message }}</div>
      </div>
      <div class="error__button">
        <BravadoButtonV3 size="md" variant="accent" @click="$router.push($pages.WAR_ROOM_POSTS_TAB_MYFEED_PAGE.path)">
          take me back
        </BravadoButtonV3>
      </div>
      <img
        src="./assets/error.webp"
        width="750"
        height="492"
        class="error__img"
        alt="logo showing that an error occurred"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'ErrorLayout',
  components: { BravadoButtonV3 },
  layout: 'clear',
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isProd: process.env.isProduction,
    };
  },
});
</script>

<style lang="scss" scoped>
.error-container {
  background: var(--white);
}

.error {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  height: auto;
  min-height: 100vh;
  background: #fff;
  font-family: var(--font-family);
  box-sizing: border-box;
  padding: 159px 242px 0 242px;
  color: #000;

  &__header {
    font-size: 36px;
    font-weight: 300;
    margin-bottom: 9px;
  }

  &__tip {
    color: rgba(0, 0, 0, 0.54);
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 38px;
  }

  &__img {
    width: 750px;
    max-width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: 0;
  }

  &__button {
    margin-bottom: 60px;
  }

  &__debug {
    font-size: 18px;
    margin: 30px 0;
    border: 2px dashed var(--red-30);
    border-radius: 5px;
    padding: 20px;
    position: relative;

    &::after {
      content: 'shows up only in dev mode';
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 10px;
      color: var(--red-30);
    }
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 576px) {
  .error {
    max-width: 100%;
    padding: 24px;
    text-align: center;
  }

  .error_img {
    max-width: 100%;
    width: 100%;
  }
}
</style>
